
<iframe [src]="url" style="width: 100%;height: 100%;border: none;"></iframe>
